export enum HourFormatEnum {
  AM_PM = 'AM/PM',
  Horas_24 = '24 Horas',
}
